import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !(cfg.url || "").startsWith("/auth/")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("auth:logout"));
      }
    }
    return Promise.reject(err);
  }
);

const FR = {
  "A pending invitation already exists for this email": "Une invitation en attente existe déjà pour cet e-mail",
  "Invalid or expired invitation": "Invitation invalide ou expirée",
  "Invalid or expired link": "Lien invalide ou expiré",
  "Invitation is not pending": "Cette invitation n'est plus en attente",
};

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Error";
  if (typeof d === "string") return (localStorage.getItem("lang") || "fr") === "fr" && FR[d] ? FR[d] : d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return JSON.stringify(d);
}

export async function downloadFile(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const fmtDate = (s, withTime = true) =>
  s ? new Date(s).toLocaleString("fr-FR", withTime ? { dateStyle: "short", timeStyle: "short" } : { dateStyle: "short" }) : "—";
